/* =========================================================
   NoSkinKolor — Theme JS
   Shopify AJAX Cart API replaces localStorage cart.
   All UI interactions ported from original script.js.
   ========================================================= */

/* ---------- Money formatter ---------- */
function fmt(cents) {
  var n = (cents / 100).toFixed(2).replace('.', ',');
  return n + ' €';
}

/* ---------- Translation bridge (works with i18n.js) ---------- */
function T(s) {
  return (window.t ? window.t(s) : s);
}

/* ---------- Toast ---------- */
var toastTimer;
function toast(msg) {
  var el = document.querySelector('.toast');
  if (!el) {
    el = document.createElement('div');
    el.className = 'toast';
    document.body.appendChild(el);
  }
  el.textContent = msg;
  el.classList.add('show');
  clearTimeout(toastTimer);
  toastTimer = setTimeout(function () { el.classList.remove('show'); }, 1900);
}

/* ---------- Shopify AJAX Cart ---------- */
function cartFetch(url, opts) {
  return fetch(url, Object.assign({ headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' } }, opts))
    .then(function (r) { return r.json(); });
}

function getAjaxCart() {
  return cartFetch('/cart.js');
}

function addToCartAjax(variantId, quantity) {
  return cartFetch('/cart/add.js', {
    method: 'POST',
    body: JSON.stringify({ items: [{ id: variantId, quantity: quantity || 1 }] })
  });
}

function changeCartAjax(lineKey, quantity) {
  return cartFetch('/cart/change.js', {
    method: 'POST',
    body: JSON.stringify({ id: lineKey, quantity: quantity })
  });
}

function updateBadge(count) {
  document.querySelectorAll('.bag-count').forEach(function (el) {
    el.textContent = count || '';
    el.style.display = count > 0 ? 'inline-flex' : 'none';
  });
  document.querySelectorAll('.cart-count-num').forEach(function (el) {
    el.textContent = '(' + (count || 0) + ')';
  });
}

function renderCartItems(cart) {
  var body = document.querySelector('.cart-body');
  var foot = document.querySelector('.cart-foot');
  var ship = document.querySelector('.ship-bar');
  if (!body) return;

  var threshold = (window.NSK && window.NSK.freeShippingThreshold) || 4999;
  var subtotal = cart.total_price || 0;
  var remaining = Math.max(0, threshold - subtotal);
  var pct = threshold > 0 ? Math.min(100, (subtotal / threshold) * 100) : 100;

  updateBadge(cart.item_count);

  if (!cart.item_count) {
    body.innerHTML =
      '<div class="cart-empty">' +
        '<div class="em-title">' + T('Your bag is empty') + '</div>' +
        '<p>' + T('Pieces you love live here.') + '<br>' + T('Start with the new drop.') + '</p>' +
        '<a href="/collections/frontpage" class="btn-line">' + T('Shop New Arrivals →') + '</a>' +
      '</div>';
    if (foot) foot.style.display = 'none';
    if (ship) ship.style.display = 'none';
    return;
  }

  if (foot) foot.style.display = 'flex';

  if (ship) {
    if (threshold > 0) {
      ship.style.display = 'flex';
      var shipMsg = remaining > 0
        ? T('Add {x} for free shipping').replace('{x}', fmt(remaining))
        : T('Free shipping unlocked ❖');
      ship.innerHTML =
        '<div>' + shipMsg + '</div>' +
        '<div class="progress"><div class="progress-fill" style="width:' + pct + '%"></div></div>';
    } else {
      ship.style.display = 'none';
    }
  }

  var itemsHtml = cart.items.map(function (item) {
    var imgHtml = item.image
      ? '<div class="cart-item-img" style="background-image:url(\'' + item.image + '\');background-size:cover;background-position:center;"></div>'
      : '<div class="cart-item-img"></div>';
    return (
      '<div class="cart-item">' +
        imgHtml +
        '<div class="cart-item-info">' +
          '<span class="name">' + item.product_title + '</span>' +
          '<span class="vari">' + T('Size') + ' · ' + item.variant_title + '</span>' +
          '<div class="row">' +
            '<div class="qty">' +
              '<button data-act="dec" data-key="' + item.key + '">−</button>' +
              '<span>' + item.quantity + '</span>' +
              '<button data-act="inc" data-key="' + item.key + '">+</button>' +
            '</div>' +
            '<span>' + fmt(item.line_price) + '</span>' +
          '</div>' +
          '<button class="remove" data-act="rm" data-key="' + item.key + '">' + T('Remove') + '</button>' +
        '</div>' +
      '</div>'
    );
  }).join('');

  body.innerHTML = '<div class="cart-items">' + itemsHtml + '</div>';

  if (foot) {
    foot.innerHTML =
      '<div class="totals"><span>' + T('Subtotal') + '</span><span class="big">' + fmt(subtotal) + '</span></div>' +
      '<div class="totals" style="color:var(--muted-2)"><span>' + T('Shipping') + '</span><span>' + T('Calculated at checkout') + '</span></div>' +
      '<button class="btn-primary cart-checkout">' + T('Checkout') + ' — ' + fmt(subtotal) + ' <span>→</span></button>' +
      '<button class="btn-secondary cart-close-x">' + T('Continue Shopping') + '</button>';

    foot.querySelector('.cart-checkout').addEventListener('click', function () {
      window.location.href = '/checkout';
    });
    foot.querySelector('.cart-close-x').addEventListener('click', closeCart);
  }

  body.querySelectorAll('[data-act]').forEach(function (b) {
    b.addEventListener('click', function () {
      var key = b.dataset.key;
      var act = b.dataset.act;
      if (act === 'inc') {
        var curQty = parseInt(b.parentNode.querySelector('span').textContent, 10);
        changeCartAjax(key, curQty + 1).then(refreshCart);
      } else if (act === 'dec') {
        var curQty2 = parseInt(b.parentNode.querySelector('span').textContent, 10);
        changeCartAjax(key, Math.max(0, curQty2 - 1)).then(refreshCart);
      } else if (act === 'rm') {
        changeCartAjax(key, 0).then(refreshCart);
      }
    });
  });
}

function refreshCart() {
  return getAjaxCart().then(renderCartItems);
}

function openCart() {
  var cart = document.querySelector('.cart');
  var scrim = document.querySelector('.scrim');
  if (cart) cart.classList.add('open');
  if (scrim) { scrim.classList.add('open'); scrim.classList.remove('scrim-light'); }
  refreshCart();
}

function closeCart() {
  var cart = document.querySelector('.cart');
  var scrim = document.querySelector('.scrim');
  if (cart) cart.classList.remove('open');
  if (scrim) scrim.classList.remove('open');
}

function initCart() {
  document.querySelectorAll('.bag-trigger').forEach(function (b) {
    b.addEventListener('click', openCart);
  });
  var cartClose = document.querySelector('.cart-close');
  if (cartClose) cartClose.addEventListener('click', closeCart);
  var scrim = document.querySelector('.scrim');
  if (scrim) scrim.addEventListener('click', closeCart);
  refreshCart();
  window.addEventListener('nsk-langchange', refreshCart);
}

/* ---------- Header ---------- */
function initHeader() {
  var header = document.querySelector('.header');
  if (!header) return;
  var onScroll = function () { header.classList.toggle('scrolled', window.scrollY > 30); };
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });
}

/* ---------- Shop dropdown ---------- */
function initShopDropdown() {
  var wrap = document.querySelector('.shop-wrap');
  if (!wrap) return;
  var timeout;
  var open = function () { clearTimeout(timeout); wrap.classList.add('open'); };
  var close = function () { timeout = setTimeout(function () { wrap.classList.remove('open'); }, 120); };
  wrap.addEventListener('mouseenter', open);
  wrap.addEventListener('mouseleave', close);
  document.addEventListener('click', function (e) {
    if (!wrap.contains(e.target)) wrap.classList.remove('open');
  });
}

/* ---------- Full-screen menu ---------- */
function initMenu() {
  var menu = document.querySelector('.menu');
  if (!menu) return;
  var scrim = document.querySelector('.scrim');

  function openMenu() {
    menu.classList.add('open');
    if (scrim) { scrim.classList.add('open', 'scrim-light'); }
  }
  function closeMenu() {
    menu.classList.remove('open');
    if (scrim) { scrim.classList.remove('open', 'scrim-light'); }
  }

  document.querySelectorAll('.hamburger, .menu-open').forEach(function (b) {
    b.addEventListener('click', function (e) { e.preventDefault(); openMenu(); });
  });

  var menuClose = menu.querySelector('.menu-close');
  if (menuClose) menuClose.addEventListener('click', closeMenu);
  if (scrim) scrim.addEventListener('click', closeMenu);
  menu.querySelectorAll('.bag-trigger').forEach(function (b) { b.addEventListener('click', closeMenu); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeMenu(); closeCart(); } });
}

/* ---------- Search ---------- */
function initSearch() {
  var overlay = document.getElementById('nsk-search-overlay');
  if (!overlay) return;

  var input = overlay.querySelector('.search-input');
  var results = overlay.querySelector('.search-results');
  var searchUrl = (input && input.dataset.searchUrl) || '/search';

  function openSearch() {
    var menu = document.querySelector('.menu');
    if (menu) menu.classList.remove('open');
    overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
    setTimeout(function () { if (input) input.focus(); }, 140);
  }
  function closeSearch() {
    overlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  document.querySelectorAll('.search-trigger').forEach(function (t) {
    t.addEventListener('click', function (e) { e.preventDefault(); openSearch(); });
  });
  var closeBtn = overlay.querySelector('.search-close');
  if (closeBtn) closeBtn.addEventListener('click', closeSearch);
  overlay.addEventListener('click', function (e) { if (e.target === overlay) closeSearch(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSearch(); });

  if (input) {
    input.addEventListener('input', function () {
      var q = input.value.trim();
      if (!q) { results.innerHTML = ''; return; }
      fetch(searchUrl + '?type=product&q=' + encodeURIComponent(q) + '&view=json')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (!data.results || !data.results.length) {
            results.innerHTML = '<div class="search-hint">' + T('No results for {q}.').replace('{q}', '“' + q + '”') + '</div>';
            return;
          }
          results.innerHTML = data.results.slice(0, 8).map(function (p) {
            return '<a class="search-item" href="' + p.url + '">' +
              '<span class="si-name">' + p.title + '</span>' +
              '<span class="si-price">' + (p.price ? fmt(p.price) : '') + '</span>' +
              '</a>';
          }).join('');
        })
        .catch(function () { results.innerHTML = ''; });
    });
  }

  window.addEventListener('nsk-langchange', function () {
    if (input) input.placeholder = T('Search products…');
  });
}

/* ---------- Accordion (support page) ---------- */
function initAccordion() {
  document.querySelectorAll('.acc-trigger').forEach(function (t) {
    t.addEventListener('click', function () {
      t.closest('.acc-item').classList.toggle('open');
    });
  });

  document.querySelectorAll('.support-side a').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var id = a.getAttribute('href');
      if (id && id.startsWith('#')) {
        e.preventDefault();
        var target = document.querySelector(id);
        if (target) {
          target.classList.add('open');
          var y = target.getBoundingClientRect().top + window.scrollY - 140;
          window.scrollTo({ top: y, behavior: 'smooth' });
        }
      }
    });
  });

  function openFromHash() {
    var h = location.hash;
    if (!h || h.length < 2) return;
    var target;
    try { target = document.querySelector(h); } catch (e) { return; }
    if (target && target.classList.contains('acc-item')) {
      target.classList.add('open');
      var y = target.getBoundingClientRect().top + window.scrollY - 120;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  }
  setTimeout(openFromHash, 220);
  window.addEventListener('hashchange', openFromHash);
}

/* ---------- Reveal on scroll ---------- */
function initReveal() {
  var els = document.querySelectorAll('.reveal');
  if (!els.length) return;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
    });
  }, { threshold: 0.12 });
  els.forEach(function (el) { io.observe(el); });
}

/* ---------- Product page ---------- */
function initProductPage() {
  var stage = document.getElementById('gal-stage');
  if (!stage) return;

  var slides = Array.from(stage.querySelectorAll('img'));
  var thumbs = Array.from(document.querySelectorAll('.gal-thumbs .thumb'));
  var curEl = document.getElementById('gal-cur');
  var idx = 0;

  function show(n) {
    idx = ((n % slides.length) + slides.length) % slides.length;
    slides.forEach(function (s, i) { s.classList.toggle('active', i === idx); });
    thumbs.forEach(function (t, i) { t.classList.toggle('active', i === idx); });
    if (curEl) curEl.textContent = idx + 1;
  }

  var prevBtn = document.getElementById('gal-prev');
  var nextBtn = document.getElementById('gal-next');
  if (prevBtn) prevBtn.addEventListener('click', function () { show(idx - 1); });
  if (nextBtn) nextBtn.addEventListener('click', function () { show(idx + 1); });
  thumbs.forEach(function (t) { t.addEventListener('click', function () { show(+t.dataset.idx); }); });

  /* Hover-to-zoom */
  if (stage && window.matchMedia('(hover: hover)').matches) {
    stage.addEventListener('mouseenter', function () { stage.classList.add('zooming'); });
    stage.addEventListener('mouseleave', function () {
      stage.classList.remove('zooming');
      var a = stage.querySelector('img.active');
      if (a) a.style.transformOrigin = 'center center';
    });
    stage.addEventListener('mousemove', function (e) {
      var r = stage.getBoundingClientRect();
      var x = ((e.clientX - r.left) / r.width) * 100;
      var y = ((e.clientY - r.top) / r.height) * 100;
      var a = stage.querySelector('img.active');
      if (a) a.style.transformOrigin = x + '% ' + y + '%';
    });
  }

  /* Variant / size selection */
  var productData = window.NSK_PRODUCT;
  var selectedVariantId = productData ? productData.selectedVariantId : null;
  var selectedSize = null;

  function findVariant(sizeName) {
    if (!productData || !productData.variants) return null;
    return productData.variants.find(function (v) {
      return v.options.indexOf(sizeName) !== -1;
    }) || null;
  }

  document.querySelectorAll('.size-btn').forEach(function (b) {
    b.addEventListener('click', function () {
      if (b.classList.contains('out')) return;
      document.querySelectorAll('.size-btn').forEach(function (x) { x.classList.remove('active'); });
      b.classList.add('active');
      selectedSize = b.dataset.size;
      var variant = findVariant(selectedSize);
      if (variant) {
        selectedVariantId = variant.id;
        var priceEl = document.getElementById('pdp-price');
        if (priceEl) priceEl.textContent = fmt(variant.price);
        var addBtn = document.getElementById('add-cart');
        if (addBtn) addBtn.dataset.variantId = variant.id;
      }
    });
  });

  /* Quantity */
  var qty = 1;
  var qval = document.getElementById('qty-val');
  var qDec = document.getElementById('qty-dec');
  var qInc = document.getElementById('qty-inc');
  if (qDec) qDec.addEventListener('click', function () { qty = Math.max(1, qty - 1); if (qval) qval.textContent = qty; });
  if (qInc) qInc.addEventListener('click', function () { qty = Math.min(10, qty + 1); if (qval) qval.textContent = qty; });

  /* Add to cart */
  var addBtn = document.getElementById('add-cart');
  if (addBtn) {
    addBtn.addEventListener('click', function () {
      var varId = parseInt(addBtn.dataset.variantId || selectedVariantId, 10);
      if (!varId) { toast('Please select a size'); return; }
      addToCartAjax(varId, qty)
        .then(function (result) {
          if (result.status) {
            toast(result.description || 'Could not add to bag');
            return;
          }
          addBtn.classList.add('added');
          addBtn.textContent = T('✓ Added');
          setTimeout(function () {
            addBtn.classList.remove('added');
            addBtn.textContent = T('Add to bag');
          }, 1500);
          openCart();
        })
        .catch(function () { toast('Error — please try again'); });
    });
  }
}

/* ---------- Hero slider (archive) ---------- */
function initHero() {
  var slides = document.querySelectorAll('.hero-slide');
  var dots = document.querySelectorAll('.hero-dots button');
  if (!slides.length) return;
  var i = 0;
  var go = function (n) {
    i = ((n % slides.length) + slides.length) % slides.length;
    slides.forEach(function (s, k) { s.classList.toggle('active', k === i); });
    dots.forEach(function (d, k) { d.classList.toggle('active', k === i); });
  };
  dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); }); });
  var timer = setInterval(function () { go(i + 1); }, 6000);
  var hero = document.querySelector('.hero');
  if (hero) {
    hero.addEventListener('mouseenter', function () { clearInterval(timer); });
    hero.addEventListener('mouseleave', function () { timer = setInterval(function () { go(i + 1); }, 6000); });
  }
}

/* ---------- Boot ---------- */
document.addEventListener('DOMContentLoaded', function () {
  initHeader();
  initShopDropdown();
  initMenu();
  initCart();
  initSearch();
  initHero();
  initReveal();
  initAccordion();
  initProductPage();
});
